import React from 'react';
import connect from 'Shared/connect';
import classnames from 'classnames';
import { translate } from 'Shared/translate';
import ProductRow, { AppearanceNameType as ProductRowApperance } from 'Shared/ProductRow';
import ProductHeaderRow from 'Shared/ProductRow/header';
import { SMALL } from 'Shared/breakpoints';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import ReplacementProduct from 'Shared/ReplacementProduct';
import { addToCart } from './../Cart/action-creators';
import { updateShoppingList, clearShoppingList } from './action-creators';
import Dialog, { DialogType } from 'Shared/Dialog';
import { selectVariant } from 'Shared/Product/action-creators';
import { getShoppingList } from './reducer';
import * as styles from './Pages/page.scss';
class ShoppingList extends React.Component {
    constructor(props) {
        super(props);
        this.updateQuantity = (item, code, quantity) => {
            const unitShortName = item.product.variants.filter(v => v.code === code)[0].unitShortName;
            return this.props.updateListItem(code, quantity, unitShortName);
        };
        this.selectVariant = (item, previousCode, newCode) => {
            const previousVariant = item.product.variants.find(v => v.code === previousCode);
            const newVariant = item.product.variants.find(v => v.code === newCode);
            const quantity = this.props.shoppingList.find(listItem => listItem.code === previousCode).quantity;
            this.props.updateListItem(previousCode, quantity, previousVariant.unitShortName);
            return this.props.updateListItem(newCode, item.quantity, newVariant.unitShortName);
        };
        this.componentDidMount = () => {
            return Promise.all(this.props.items.map(item => this.props.selectVariant(item.selectedVariant.code, item.product.variants)));
        };
        this.addProducts = () => {
            return Promise.all(this.props.shoppingList.map(add => this.props.addToCart(add.code, add.quantity, add.unitShortName, add.ticket))).then(() => Promise.resolve());
        };
        this.onAddedToCart = () => {
            clearShoppingList();
            this.props.hideModal();
        };
    }
    render() {
        const props = this.props;
        return (React.createElement("div", null, !!props.items && !!props.items.length ? (React.createElement("div", { className: styles.shoppingListWrapper },
            React.createElement(ProductHeaderRow, { appearance: "compact", hasAmountNeeded: true, hasDelete: true, isCart: false, isCheckout: false, currentBreakpoint: props.currentBreakpoint }),
            React.createElement("div", { className: classnames(styles.shoppingList) }, props.items.map((item, i) => {
                const productItem = !!item.product.isDiscontinued || !!item.product.isBackorderReplaced
                    ? item.product.replacementProduct
                    : item.product;
                const listItem = this.props.shoppingList.find(listItem => item.selectedVariant.code === listItem.code);
                return (!!listItem && (React.createElement("div", { key: `wrapper_${listItem.code}_${i}` },
                    (!!item.product.isDiscontinued || !!item.product.isBackorderReplaced) && (React.createElement(ReplacementProduct, Object.assign({ key: epiPropertyValue(item.product.content.code), appearance: props.currentBreakpoint > SMALL ? 'row' : 'mobile', product: item.product }, props))),
                    !!productItem && (React.createElement(ProductRow, Object.assign({ appearance: ProductRowApperance.Compact }, productItem, props, { removeCartItem: () => props.removeListItem(listItem.code, listItem.unitShortName), updateQuantity: (code, quantity) => this.updateQuantity(item, code, quantity), quantity: listItem.quantity, selectedVariant: productItem.variants.find(v => v.unitShortName === listItem.unitShortName), onSelectVariant: (previousCode, newCode) => this.selectVariant(item, previousCode, newCode), amountNeeded: item.amountNeeded, key: listItem.code, rowIndex: i, location: "ShoppingList" }))))));
            })),
            React.createElement(Dialog, { type: DialogType.OkOnly, onConfirm: this.addProducts, onCancel: this.props.hideModal, onStatusWasFulfilled: this.onAddedToCart, customAcceptText: translate('/AddOrder/AddToCart') }))) : (React.createElement("div", { className: styles.shoppingListWrapper },
            React.createElement("b", null, translate('/Recipe/ShoppingListEmpty'))))));
    }
}
export default connect(state => ({
    currentBreakpoint: state.currentBreakpoint,
    shoppingList: getShoppingList(state),
}), dispatch => ({
    addToCart: (code, quantity, unitShortName, ticket) => dispatch(addToCart(code, quantity, unitShortName, ticket, 'ShoppingList')),
    updateUnit(items) {
        const code = items && Object.keys(items)[0];
        return dispatch(updateShoppingList(code, items[code].newQuantity, items[code].newUnitShortName));
    },
    updateListItem: (code, quantity, unitShortName) => dispatch(updateShoppingList(code, quantity, unitShortName)),
    removeListItem: (code, unitShortName) => dispatch(updateShoppingList(code, null, unitShortName)),
    selectVariant: (code, variants) => dispatch(selectVariant(code, variants)),
}))(ShoppingList);
